import { formatDate } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'

import { FullDateFilterState } from './full-date-filter.state'

import { imports } from './full-date-filter.imports'

@Component({
	selector: 'full-date-filter',
	templateUrl: './full-date-filter.component.html',
	styleUrl: './full-date-filter.component.scss',
	imports,
})
export class FullDateFilterComponent implements OnInit {
	readonly #ref = inject(MatDialogRef)
	readonly #fullDateFilterState = inject(FullDateFilterState)

	readonly isTicketTransactionsPage = this.#fullDateFilterState.isTicketTransactionsPage
	readonly isDateRange = this.#fullDateFilterState.isDateRange
	readonly form = new FormGroup({
		dateRange: new FormGroup({
			start: new FormControl<Date>(new Date(), [Validators.required]),
			end: new FormControl<Date>(new Date(), [Validators.required]),
		}),
		searchByParked: new FormControl<boolean>(true),
		searchByCheckout: new FormControl<boolean>(true),
		searchByTempCheckout: new FormControl<boolean>(true),
	})
	readonly overnight = new FormControl<boolean>(
		this.#fullDateFilterState.isTicketTransactionsOvernight()
	)

	ngOnInit(): void {
		this.#setFormValues()
	}

	#setFormValues(): void {
		const { startDate, endDate, searchByParked, searchByCheckout, searchByTempCheckout } =
			this.#fullDateFilterState.signalFullDate()
		const dateRange = {
			start: new Date(startDate),
			end: new Date(endDate),
		}

		this.form.setValue({ dateRange, searchByParked, searchByCheckout, searchByTempCheckout })
	}

	onSubmit(): void {
		this.#ref.close(true)
		this.#setFullDate()
	}

	#setFullDate(): void {
		const {
			dateRange: { start, end },
			searchByCheckout,
			searchByParked,
			searchByTempCheckout,
		} = this.form.getRawValue()
		const startDate = formatDate(start, 'yyyy-MM-ddT00:00:00.000000', 'en-US')
		const endDate = formatDate(end, 'yyyy-MM-ddT23:59:59.999999', 'en-US')
		const fullDate = {
			startDate,
			endDate,
			searchByCheckout,
			searchByParked,
			searchByTempCheckout,
		}

		this.#fullDateFilterState.isTicketTransactionsOvernight.set(this.overnight.value)
		this.#fullDateFilterState.signalFullDate.set(fullDate)
	}
}
